module.exports = __webpack_public_path__ + "assets/fonts/Gotham-ThinItalic.671f0216.otf";